<template>
  <div class="header">
<!--    <div class="tTop">-->
<!--      <span>欢迎进入贾汪区三乡工程数据平台</span><p><a>{{user}}</a>|<a @click="loginOut">退出登录</a></p>-->
<!--    </div>-->
    <div class="hTop">
      <img
        class="logo"
        src="../../assets/images/mingzi_icon.png"
      />
      <div class="nav">
        <ul>
          <li v-if="qx1 == 1">
            <router-link :to="{name:'home'}">
              <img
                v-if="nav != 1"
                src="../../assets/images/nav/shouye_icon.png"
              />
              <img
                v-if="nav == 1"
                src="../../assets/images/nav/shouye_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx2 == 2">
            <router-link :to="{name:'nengrenku'}">
              <img
                v-if="nav != 2"
                src="../../assets/images/nav/nengrenku_icon.png"
              />
              <img
                v-if="nav == 2"
                src="../../assets/images/nav/nengrenku_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx3 == 3">
            <router-link :to="{name:'rencaiku'}">
              <img
                v-if="nav != 3"
                src="../../assets/images/nav/rencaiku_icon.png"
              />
              <img
                v-if="nav == 3"
                src="../../assets/images/nav/rencaiku_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx10 == 15">
            <router-link :to="{name:'zhuanjiaku'}">
              <img
                v-if="nav != 15"
                src="../../assets/images/nav/zhuanjiaku.png"
              />
              <img
                v-if="nav == 15"
                src="../../assets/images/nav/zhuanjiaku_xuanzhong.png"
              />
            </router-link>
          </li>
          <li v-if="qx4 == 4">
            <router-link :to="{name:'xiangmuku'}">
              <img
                v-if="nav != 4"
                src="../../assets/images/nav/xiangmuku_icon.png"
              />
              <img
                v-if="nav == 4"
                src="../../assets/images/nav/xiangmuku_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx11 == 17">
            <router-link :to="{name:'weifanxiang'}">
              <img
                v-if="nav != 17"
                src="../../assets/images/nav/weinengfanxiangnengrenku.png"
              />
              <img
                v-if="nav == 17"
                src="../../assets/images/nav/weinengfanxiangnengrenku_xuan.png"
              />
            </router-link>
          </li>
          <li v-if="qx5 == 5">
            <router-link :to="{name:'ziyuanku'}">
              <img
                v-if="nav != 5"
                src="../../assets/images/nav/ziyuanku_icon.png"
              />
              <img
                v-if="nav == 5"
                src="../../assets/images/nav/ziyuanku_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx6 == 6">
            <router-link :to="{name:'zhengcexinxi'}">
              <img
                v-if="nav != 6"
                src="../../assets/images/nav/zhengcexinxi_icon.png"
              />
              <img
                v-if="nav == 6"
                src="../../assets/images/nav/zhengcexinxi_icon_pre.png"
              />

            </router-link>
          </li>
          <li v-if="qx7 == 7">
            <router-link :to="{name:'xiangcunyuanqu'}">
              <img
                v-if="nav != 7"
                src="../../assets/images/nav/xiangcunyuanqu_icon.png"
              />
              <img
                v-if="nav == 7"
                src="../../assets/images/nav/xiangcunyuanqu_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx8 == 8">
            <router-link :to="{name:'xinnongxie'}">
              <img
                v-if="nav != 8"
                src="../../assets/images/nav/xinnongxie_icon.png"
              />
              <img
                v-if="nav == 8"
                src="../../assets/images/nav/xinnongxie_icon_pre.png"
              />
            </router-link>
          </li>
          <li v-if="qx9 == 9">
            <router-link :to="{name:'data'}">
              <img
                v-if="nav != 9"
                src="../../assets/images/nav/shujutongji_icon.png"
              />
              <img
                v-if="nav == 9"
                src="../../assets/images/nav/shujutongji_icon_pre.png"
              />
            </router-link>
          </li>

        </ul>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "top",
  data() {
    return {
      user:'',
      nav: 1,
      qx1:null,
      qx2:null,
      qx3:null,
      qx4:null,
      qx5:null,
      qx6:null,
      qx7:null,
      qx8:null,
      qx9:null,
      qx10:null,
      qx11:null,
    };
  },
  watch: {
    $route: {
      handler(val, oldVal) {
        if (val.name == "home") {
          this.nav = 1;
        }
        if (val.name == "nengrenku") {
          this.nav = 2;
        }
        if (val.name == "rencaiku") {
          this.nav = 3;
        }
        if (val.name == "xiangmuku") {
          this.nav = 4;
        }
        if (val.name == "ziyuanku") {
          this.nav = 5;
        }
        if (val.name == "zhengcexinxi") {
          this.nav = 6;
        }
        if (val.name == "xiangcunyuanqu") {
          this.nav = 7;
        }
        if (val.name == "xinnongxie") {
          this.nav = 8;
        }
        if (val.name == "data") {
          this.nav = 9;
        }
        if (val.name == "zhuanjiaku") {
          this.nav = 15;
        }
        if (val.name == "weifanxiang") {
          this.nav = 17;
        }
        let str = ''
        if(sessionStorage.getItem('user')){
          this.user = JSON.parse(sessionStorage.getItem('user')).account
          str = JSON.parse(sessionStorage.getItem('user')).moduleIdList
        }else{
          this.$router.replace('login')
        }
        this.qx1 = str.indexOf(1) > -1 ? 1 : null
        this.qx2 = str.indexOf(2) > -1 ? 2 : null
        this.qx3 = str.indexOf(3) > -1 ? 3 : null
        this.qx4 = str.indexOf(4) > -1 ? 4 : null
        this.qx5 = str.indexOf(5) > -1 ? 5 : null
        this.qx6 = str.indexOf(6) > -1 ? 6 : null
        this.qx7 = str.indexOf(7) > -1 ? 7 : null
        this.qx8 = str.indexOf(8) > -1 ? 8 : null
        this.qx9 = str.indexOf(9) > -1 ? 9 : null
        this.qx10 = str.indexOf(15) > -1 ? 15 : null
        this.qx11 = str.indexOf(17) > -1 ? 17 : null

      },
      // 深度观察监听
      deep: true
    }
  },
  created() {},
  mounted() {

  },
  methods: {
    loginOut() {
        this.$confirm('确定要退出系统吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$message({
            type: 'success',
            message: '退出成功!'
          });
          sessionStorage.removeItem('user')
          setTimeout(() => {
              this.$router.replace('login')
          }, 1000);
        }).catch(() => {

        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.loginOut{
  margin-top: 10px;
  margin-right: 5px;
}
.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  .tTop{
    background: #FFF;
    padding: 10px 0 10px 30px;
    text-align: right;
    display: flex;
    align-items: center;
    p{
      margin-left: auto;
    }
    a{
      margin: 0 15px;
      &:nth-of-type(2){
        cursor: pointer;
        &:hover{
          color: #333;
        }
      }
    }
    color: #666;
  }
  .hTop{
     display: flex;
    align-items: center;
  }
  .logo {
    width: 11.5vw;
    height: auto;
    margin-left: 25px;
  }
  .nav {
    margin-left: auto;
    ul {
      display: flex;
      align-items: center;
    }
    li {
      text-align: center;
      cursor: pointer;
      img {
        width: 7.8vw;
        height: auto;
      }
    }
  }
}
// 笔记本
/*@media screen and (min-width: 1366px) and (max-width: 1600px){*/
/*  .header{*/
/*    .logo {*/
/*      width: 220px;*/
/*      height: 65px;*/
/*    }*/
/*      .nav{*/
/*        li{*/
/*          img{*/
/*            width: 115px;*/
/*            height: 95px;*/
/*          }*/
/*        }*/
/*      }*/
/*  }*/
/*}*/
/*@media screen and (max-width: 1366px) {*/
/*  .header{*/
/*    .logo {*/
/*      width: 167px;*/
/*      height: 50px;*/
/*    }*/
/*      .nav{*/
/*        li{*/
/*          img{*/
/*            width: 115px;*/
/*            height: 95px;*/
/*          }*/
/*        }*/
/*      }*/
/*  }*/

/*}*/
</style>



// WEBPACK FOOTER //
// src/views/top/index.vue